import { ChangeEvent, useEffect, useState } from "react";
import { Button, Card, CardContent, FormControl, Grid, Input, InputLabel } from "@material-ui/core";
import { Sync } from "@material-ui/icons";
import { IVjtGetterCardProps } from "./props";
import "./vjt-getter-card.scss";

/** Starts export and data acquiration process, with configurable input fields */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function VjtGetterCard(props: IVjtGetterCardProps)
{
    const [megnevezes, setMegnevezes] = useState(props.megnevezes);

    useEffect(() =>
    {
        setMegnevezes(props.megnevezes);
    },[props.megnevezes]);

    const handleMegnevezesChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    {
        props.onMegnevezesChange(event.target.value);
    };

    return (
        <Card>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={8} >
                        <FormControl variant="standard">
                            <InputLabel>Megnevezés</InputLabel>
                            <Input
                                value={megnevezes}
                                onChange={handleMegnevezesChange}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} className="vjt-getter-button-item" >
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Sync />}
                            onClick={props.onButtonClick}
                        >
                            Lekérem
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );


}
